import { render } from "./QuestionListLayout.vue?vue&type=template&id=2dbf88bc&scoped=true"
import script from "./QuestionListLayout.vue?vue&type=script&lang=js"
export * from "./QuestionListLayout.vue?vue&type=script&lang=js"

import "./QuestionListLayout.vue?vue&type=style&index=0&id=2dbf88bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbf88bc"]])

export default __exports__